import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, USER_ROLES } from 'cpool-constants';
import { schemaSystemVariableResolver_GetBucketConfigurations } from 'cpool-tables/backend-resolvers';

import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';

const bucketConfigurationsOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.SYSTEM_VARIABLE,
    resolverName: 'getBucketConfigurations',
    schema: schemaSystemVariableResolver_GetBucketConfigurations,
});

export const Route = createFileRoute('/_app/management/bucket/configurations')({
    beforeLoad: ({ location }) => {
        authoriseUser([USER_ROLES.corporation_director], location);
        const content = 'ROUTE_TITLE.BUCKETS';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: ({ context }) => context.queryClient.ensureQueryData(bucketConfigurationsOptions),
});
